// app/frontend/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { useAdminStore } from '../stores/admin'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  }
})

// Pages de l'admin : vérifie la session avant d'afficher, et renvoie vers la connexion sinon.
// Simple confort d'affichage — la vraie protection est côté serveur, chaque appel /api/admin
// exigeant la session.
router.beforeEach(async (to) => {
  if (!to.meta.requiresAdmin) return true

  const admin = useAdminStore()
  try {
    await admin.ensureChecked()
  } catch {
    // API injoignable : la page de connexion affichera l'erreur au prochain essai
  }

  if (!admin.signedIn) return { name: 'AdminLogin', query: { redirect: to.fullPath } }
  return true
})

export default router
